/**
 * Normaliza `activities.custom_data` vindo do Supabase.
 * Aceita objeto JSONB ou string JSON (às vezes duplamente serializada em imports/APIs legadas).
 */
import {
  type MeetingLinkCalendarEvent,
  parseCustomData,
  pickMeetingLink,
} from "@/lib/calendar/meetingLink";

export function parseActivityCustomData(raw: unknown): Record<string, unknown> {
  return parseCustomData(raw);
}

/**
 * URL para entrar na reunião.
 *
 * Delega para a escada canônica em `@/lib/calendar/meetingLink`, que é a mesma
 * usada pelas edge functions. Antes, cada superfície tinha a sua ordem: a
 * timeline do negócio lia só `custom_data.meet_link`, o painel da Agenda lia
 * `calendar_events.conference_url` e as automações liam uma terceira — e as
 * três discordavam para a mesma reunião.
 *
 * A assinatura antiga foi preservada; o segundo parâmetro é opcional e serve
 * para quem já tem a linha de `calendar_events` em mãos.
 */
export function resolveMeetingJoinUrl(
  activity: {
    conference_url?: string | null;
    custom_data?: unknown;
    description?: string | null;
    location?: string | null;
  },
  calendarEvent?: MeetingLinkCalendarEvent | null,
): string | null {
  return pickMeetingLink(activity, calendarEvent).url;
}
